module.exports = __webpack_public_path__ + "media/images/flag-77ab4be30771e23428904ec6cfb9e185.png";